import {Component, OnInit} from '@angular/core';
import {Title} from '@angular/platform-browser';
import {RouterService} from '../RouterService';
import { environment } from '../../environments/environment';


declare var initScript: any;

@Component({
    selector: 'app-about',
    templateUrl: './about.component.html',
    styleUrls: ['./about.component.css']
})
export class AboutComponent implements OnInit {

    title = 'About - Hitec';
    brochureURL;

    constructor(private titleService: Title, public routerService: RouterService) {
        titleService.setTitle(this.title);
        this.brochureURL = environment.brochureURL;
    }

    ngOnInit(): void {
    }

    redirect(url: string): void {
        this.routerService.redirect(url);
    }

}
